import translatable from "application/queries/translatable";

const onStructureField =
  `
  ... on StructureField {
    nameTranslatable{
      ${translatable}
    }
    options {
      key
      value
    }
    name
    path
    repeatable
    indexable
    type
    translatable
    dateType
    ratingType
    ratingValue
    crop {
      height
      width
    }
    multilineText
    complexHtmlEditor
    mapType
    required
    validationType
    validationRegex
  }
  `;

const onStructureFieldSelector =
  `
... on StructureFieldSelector {
  name
  options {
    key value
  }
  path
  repeatable
  indexable
  translatable
  multiple
  isRadioButton
  withImages
  selOptions {
      key
      valueTranslatable {
        ${translatable}
      }
  }
  selImages{
    key
    text
    media {
      id
      url
      height
      width
    }
  }
  nameTranslatable{
    ${translatable}
  }
  required
  __typename
}
`;

const fieldsStructureGroupWithoutStructureFields =
  `name
  nameTranslatable{
    ${translatable}
  }
  options {
    key
    value
  }
  path
  repeatable
  indexable
  __typename
  `;

const structureFieldsQuery =
  `
  structureFields {
    ... on StructureFieldGroup {
      ${fieldsStructureGroupWithoutStructureFields}
      structureFields {
        ... on StructureFieldGroup {
          ${fieldsStructureGroupWithoutStructureFields}
          structureFields {
            ... on StructureFieldGroup {
              ${fieldsStructureGroupWithoutStructureFields}
            }
            ${onStructureFieldSelector}
            ${onStructureField}
          }
        }
        ${onStructureFieldSelector}
        ${onStructureField}
      }
    }
    ${onStructureFieldSelector}
    ${onStructureField}
  }
  `;

export default structureFieldsQuery;